import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar/Snackbar';
import IconButton from '@material-ui/core/IconButton/IconButton';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Clear';
import * as undoSelectors from 'data/undo/undoSelectors';
import * as undoActions from 'data/undo/undoActions';
import { getFeatureFlags } from 'utils/featureFlags/selectors';

class Undo extends PureComponent {

  render() {
    return (
      <>
        {this.props.autoHideDuration > 0 && this.props.undoStack && this.props.undoStack.map((undo, index) => (
          <Snackbar
            key={undo.key}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open
            style={{
              left: 100,
              bottom: index * 70 + 20,
            }}
            autoHideDuration={this.props.autoHideDuration}
            onClose={(event, reason) => {
              if (reason !== 'clickaway') {
                this.props.dispatchDeleteUndoAction(undo);
              }
            }}
            message={
              <span id="undo-message">
                {undo.userMessage}
              </span>
            }
            action={[
              <Button
                id="undo-button"
                style={{ display: undo.actions && undo.actions.length ? undefined : 'none' }}
                key="undo"
                aria-label="undo"
                color="primary"
                onClick={() => this.props.dispatchUndoAction(undo)}
              >
                Undo
              </Button>,
              <IconButton
                id="close-undo"
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={() => this.props.dispatchDeleteUndoAction(undo)}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        ))}
      </>
    );
  }
}

Undo.propTypes = {
  undoStack: PropTypes.object,
  dispatchDeleteUndoAction: PropTypes.func,
  dispatchUndoAction: PropTypes.func,
  autoHideDuration: PropTypes.number,
};

function mapStateToProps(state) {
  const autoHideDuration = Number(getFeatureFlags(state).get('undo'));
  return {
    undoStack: undoSelectors.getUndoStack(state),
    autoHideDuration: (Number.isNaN(autoHideDuration) ? 10 : autoHideDuration) * 1000,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchDeleteUndoAction: (data) => dispatch(undoActions.deleteUndo(data)),
    dispatchUndoAction: (data) => dispatch(undoActions.undo(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Undo);
